import { useCollapseHeight } from "@finbackoffice/site-core";
import Loading from "components/base/loading/Loading";
import { ReactNode, FC, PropsWithChildren } from "react";
import classNames from "classnames";
import styles from "./advanced-sidebar-footer.module.sass";

type IProps = {
    title: string;
    icon?: ReactNode;
    loading?: boolean;
};

const CollapsingBlok: FC<IProps & PropsWithChildren> = ({ children, title, icon, loading }) => {
    const { opened, animating, headerRef, containerRef } = useCollapseHeight(false, 300);

    return (
        <div className={classNames(styles.mainMenuItem, opened && styles.opened)}>
            <div ref={!loading ? headerRef : undefined}>
                {icon}
                <p>{title}</p>
                <i className={styles.arrow} />
                {loading && <Loading />}
            </div>
            {(opened || animating) && (
                <nav ref={containerRef} className={styles.list}>
                    {children}
                </nav>
            )}
        </div>
    );
};

export default CollapsingBlok;
